module.exports = __webpack_public_path__ + "img/AS.237c209a.png";